import { render, staticRenderFns } from "./CreateTaskDecorationIcon.vue?vue&type=template&id=2673277f&"
import script from "./CreateTaskDecorationIcon.vue?vue&type=script&lang=ts&"
export * from "./CreateTaskDecorationIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports